import styled from 'styled-components';

const ArrowImg = styled.img`
  height: 20px;
  width: auto;
`;

const NextPageButtonWrapper = styled.div`
  padding: 17px 0;
`;

const PrevPageButtonWrapper = styled.div`
  padding: 17px 0;
  text-align: right;
`;

const PageNumber = styled.div`
  color: black;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PageNumberLink = styled.a`
  ${props => (props.active ? 'background-color: black; color: white;' : null)}
  font-size: 15px;
  line-height: 23px;
  height: 19px;
  cursor: pointer;
  padding: 0 5px;
  &:hover {
    text-decoration: none;
    ${props => (props.active ? 'color: white;' : null)};
  }
`;

export { ArrowImg, NextPageButtonWrapper, PrevPageButtonWrapper, PageNumber, PageNumberLink };
